import { render, staticRenderFns } from "./SingleProject.vue?vue&type=template&id=0148331b"
import script from "./SingleProject.vue?vue&type=script&lang=js"
export * from "./SingleProject.vue?vue&type=script&lang=js"
import style0 from "./SingleProject.vue?vue&type=style&index=0&id=0148331b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports